import ZeissInput from '@components/input';
import { SystemCityItemInterface } from '@store/systemCityStore';
import { Col, Form, Row } from 'antd';
import { forwardRef, useImperativeHandle } from 'react';
import './index.scss';

interface SearchFormPropsInterface {
  onFieldsChange?: () => void;
  dicList?: any;
  systemCity?: SystemCityItemInterface[];
}

const SearchForm = (props: SearchFormPropsInterface, ref: any) => {
  const { onFieldsChange } = props;
  const [form] = Form.useForm();

  const handeChange = () => {
    onFieldsChange?.();
  };

  // 校验表单内容并且返回数据
  const submitClick = () => {
    return form.validateFields();
  };

  useImperativeHandle(ref, () => ({
    submitClick,
    resetFields: form.resetFields
  }));

  return (
    <Form
      form={form}
      className="contentListForm"
      layout="vertical"
      onFieldsChange={handeChange}
    >
      <Row gutter={[24, 0]}>
        <Col span={6}>
          <Form.Item label="销售姓名" name="name">
            <ZeissInput placeholder="请输入销售姓名" allowClear />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="邮箱" name="email">
            <ZeissInput placeholder="请输入邮箱" allowClear />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default forwardRef(SearchForm);
